export const currentTimestamp = () => Math.floor(Date.now() / 1000);
